// Change personal details form for charity admins.
// @author Matthew Norris

import Form from "Scripts/common/form";
import Select2 from 'Scripts/common/select2';

export default class ChangePersonalDetails {
	constructor() {
		new Form({
			callback: this.afterPost.bind(this),
			form:     $("#js-personal-details-form"),
			willRedirect: true,
		});

		new Select2(".js-select2");
	}

	afterPost() {
		window.location.href = "/account"; // redirect to the account overview page
	}
}
